import { useFlags } from "launchdarkly-react-client-sdk";

import { useEntitlements } from "src/hooks/use-entitlement";
import { useOrganizationEntitlement } from "src/hooks/use-organization-entitlement";

/**
 * Whether Lifecycle Studio is enabled for the workspace — the
 * `appMarketingCampaignsEnabled` flag OR the `lifecycleStudio` entitlement
 * that gates the Lifecycle Studio nav section and routes.
 */
export const useLifecycleStudioEnabled = (): boolean => {
  const { appMarketingCampaignsEnabled } = useFlags();
  // Two reads of the same entitlement, deliberately — same pattern as
  // use-agents-tier. The server's is the only one that sees a staff grant from
  // the Entitlement Center; grants live in the entitlement_grants table, which
  // the org entitlements jsonb knows nothing about. The jsonb read is
  // synchronous, so it keeps this answering correctly before the query resolves
  // rather than reporting "off" and hiding the nav section on first render.
  const hasLifecycleStudioEntitlement =
    useOrganizationEntitlement("lifecycleStudio");
  const { data } = useEntitlements(true);

  return Boolean(
    appMarketingCampaignsEnabled ||
      hasLifecycleStudioEntitlement ||
      data.entitlements.lifecycleStudio,
  );
};
